exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".incDecButton[data-v-4c25862d]{width:37px;height:37px;margin-left:10px;line-height:37px;color:#fff;font-weight:700;text-align:center;background:#4e7dab;border-radius:5px;cursor:pointer}.incDecButton.incDecButtonRemove[data-v-4c25862d]{color:#818181;background:#e8e8e8}", ""]);

// exports
